export { default } from "./EcoModeToolTipDialog";
